// extracted by mini-css-extract-plugin
export default {"ctnSec":"Proyects_ctnSec__o9hf7","ctnBnts":"Proyects_ctnBnts__R9neY","text":"Proyects_text__0vUZT","ctnTxt":"Proyects_ctnTxt__rw1MC","titleSup":"Proyects_titleSup__sFEDr"};